/**
 * Brand divider — two hairlines + small heart in the middle (Olive on cream).
 * Used between sections to echo the AdventureCouple.lu print-style ornament.
 *
 * Props:
 *   width:        total visual width (default: "narrow")  → narrow | medium | wide
 *   tone:         color of the hairlines + heart (default: "olive") → olive | sand | cream
 *   className:    extra classes for the wrapper
 */
export default function HeartDivider({ width = "narrow", tone = "olive", className = "" }) {
  const widths = {
    narrow: "w-10",
    medium: "w-16",
    wide: "w-24",
  };
  const lineW = widths[width] || widths.narrow;

  const colorMap = {
    olive: "var(--wp-olive)",
    sand: "var(--wp-sand)",
    cream: "rgba(231, 222, 208, 0.65)",
  };
  const color = colorMap[tone] || colorMap.olive;

  return (
    <div
      className={`inline-flex items-center justify-center gap-3 ${className}`}
      data-testid="heart-divider"
      aria-hidden="true"
    >
      <span className={`h-px ${lineW}`} style={{ backgroundColor: color, opacity: tone === "cream" ? 0.65 : 0.5 }} />
      <svg width="14" height="13" viewBox="0 0 14 13" fill="none" className="block">
        <path
          d="M7 11.5 C 3.5 9, 1 6.5, 1 4 C 1 2, 2.5 1, 4 1 C 5.2 1, 6.3 1.7, 7 2.8 C 7.7 1.7, 8.8 1, 10 1 C 11.5 1, 13 2, 13 4 C 13 6.5, 10.5 9, 7 11.5 Z"
          fill={color}
          fillOpacity="0.9"
        />
      </svg>
      <span className={`h-px ${lineW}`} style={{ backgroundColor: color, opacity: tone === "cream" ? 0.65 : 0.5 }} />
    </div>
  );
}
